import { motion } from "framer-motion";
import { ArrowUpRight, Youtube } from "lucide-react";

const LINKS = [
    {
        name: "Spotify",
        url: "https://open.spotify.com/artist/2a7zOZH98fnhi0B6qwWN4L",
        testId: "streaming-link-spotify",
        note: "Stream the record",
    },
    {
        name: "Apple Music",
        url: "https://music.apple.com/us/album/no-light-no-sound-only-what-remains/6800926082",
        testId: "streaming-link-apple-music",
        note: "Lossless & lyrics",
    },
    {
        name: "YouTube",
        url: "https://youtube.com/@bejnni",
        testId: "streaming-link-youtube",
        note: "Videos & live sessions",
        icon: true,
    },
];

export default function StreamingFooter() {
    return (
        <footer
            data-testid="streaming-footer"
            className="relative border-t border-white/10 px-6 pb-40 pt-24 md:px-16 md:pt-40"
        >
            <div className="absolute bottom-0 left-1/2 h-[40vh] w-[60vw] -translate-x-1/2 rounded-full bg-blood/10 blur-[140px]" />

            <motion.p
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                className="mb-16 font-mono text-xs uppercase tracking-[0.3em] text-zinc-500 md:mb-24"
            >
                04 / Listen everywhere
            </motion.p>

            <div className="relative border-t border-white/10">
                {LINKS.map((link, i) => (
                    <motion.a
                        key={link.name}
                        data-testid={link.testId}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{
                            duration: 0.8,
                            delay: i * 0.1,
                            ease: [0.16, 1, 0.3, 1],
                        }}
                        className="group relative flex items-center justify-between gap-6 border-b border-white/10 py-8 md:py-12"
                    >
                        <span className="absolute bottom-0 left-0 h-px w-0 bg-blood transition-all duration-700 group-hover:w-full" />
                        <div className="flex items-baseline gap-6 md:gap-12">
                            <span className="font-mono text-xs text-zinc-600">
                                0{i + 1}
                            </span>
                            <span className="font-serif text-3xl tracking-tight text-zinc-300 transition-colors duration-500 group-hover:text-bone sm:text-5xl lg:text-6xl">
                                {link.name}
                            </span>
                        </div>
                        <div className="flex items-center gap-6">
                            <span className="hidden font-mono text-xs uppercase tracking-[0.2em] text-zinc-600 transition-colors duration-500 group-hover:text-zinc-400 md:block">
                                {link.note}
                            </span>
                            {link.icon ? (
                                <Youtube className="h-6 w-6 text-zinc-500 transition-all duration-500 group-hover:-translate-y-1 group-hover:text-blood" />
                            ) : (
                                <ArrowUpRight className="h-6 w-6 text-zinc-500 transition-all duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-blood" />
                            )}
                        </div>
                    </motion.a>
                ))}
            </div>

            <div className="relative mt-24 flex flex-col gap-4 border-t border-white/10 pt-8 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-600 md:flex-row md:items-center md:justify-between">
                <span data-testid="footer-wordmark" className="font-serif text-base italic normal-case tracking-tight text-zinc-400">
                    bejnni
                </span>
                <span>I turned everything that tried to destroy me into something worth screaming about</span>
                <span data-testid="footer-copyright">© 2026 bejnni</span>
            </div>
        </footer>
    );
}
